import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterPendency extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
    orderProductsWithErrors,
  }: OrderProductsSorterSortParams<T>): T[] {
    const withErrors: T[] = [];
    const withoutErrors: T[] = [];

    for (const op of orderProducts) {
      const orderProductKeyIds = `${op.productColorId}/${op.availability}/${op.deliveryWindow?.id || null}`;
      const productErrors = orderProductsWithErrors
        ? orderProductsWithErrors[orderProductKeyIds]
        : [];
      if (productErrors?.length > 0) {
        withErrors.push(op);
      } else {
        withoutErrors.push(op);
      }
    }

    return [...withErrors, ...withoutErrors];
  }
}

export default OrderProductsSorterPendency;
